<template>
  <div id="app">
    <!-- <router-view /> -->
    <!-- <transition :name="this.$store.state.app.routeAction"> -->
    <router-view />
    <!-- </transition> -->
  </div>
</template>

<script>
import { EventBus } from '@/utils/event-bus.js'
import { isNumber, callbackUrl } from '@/utils/index.js'
export default {
  name: 'App',
  mounted () {
    console.log('1:', window.vcluserid)
    if (window.vcluserid) {
      console.log('APP内获取到用户ID:', window.vcluserid)
      this.$store.dispatch('app/setisinapp', true)
    }
    if (window._cordovaNative) {
      this.$store.dispatch('app/setenvplatform', 'app')
    } else {
      this.$store.dispatch('app/setenvplatform', 'web')
    }

    // 判断是否为支付
    const paymoney = window.paymoney
    const url = window.vclcallback
    if (paymoney && !isNumber(paymoney)) {
      if (url) {
        this.exit(callbackUrl(url, false, '无效的支付金额'))
      } else {
        this.exit(null)
      }
    }

    EventBus.$on('vircle_reload', () => {
      this.appstart()
    })
    this.appstart()

    // if (window.paymoney) {
    //   // 调起支付页面
    //   this.paystart()
    // } else {
    //   EventBus.$on('vircle_reload', () => {
    //     this.appstart()
    //   })
    //   this.appstart()
    // }
    // 检测浏览器路由改变页面不刷新问题,hash模式的工作原理是hashchange事件
    window.addEventListener(
      'hashchange',
      () => {
        const currentPath = window.location.hash.slice(1)
        if (this.$route.path !== currentPath) {
          this.$router.push(currentPath)
        }
      },
      false
    )
  },
  computed: {
    hasLogin () {
      return this.$store.state.user.hasLogin
    },
    isinapp () {
      return this.$store.state.app.isinapp
    }
  },
  methods: {
    exit (url) {
      this.$toast.loading('退出钱包...')
      if (this.isinapp) {
        if (url) {
          window.closeWallet(url)
        } else {
          window.closeWallet(process.env.EC_URL)
        }
        // 如果是电商APP进入
        this.$toast.hide()
      } else if (this.$store.state.app.platform == 'app') {
        // APP
        navigator.app.exitApp()
      } else {
        // H5
        this.$router.replace({ path: '/' })
      }
    },
    appstart () {
      const userid = window.vcluserid

      if (userid) {
        this.$toast.loading('登录中...')
        this.$store
          .dispatch('user/loginWithId', userid)
          .then(() => {
            this.$toast.hide()
            this.initApp()
          })
          .catch((e) => {
            this.$toast.hide()
            this.logout()
            this.exit(null)
            this.$throw('[APP.VUE-appstart]' + e)
          })
      } else if (this.hasLogin) {
        this.initApp()
      } else {
        this.logout()
      }
    },
    /**
 * 加载应用
 */
    initApp () {
      const userAccount = this.$store.state.wallet.account
      console.log('加载到用户账户信息:', userAccount)
      if (!userAccount || userAccount == '') {
        this.$router.push({ path: 'addWallet' })
      } else {
        this.$toast.loading('加载中...')
        this.$store
          .dispatch('app/init')
          .then((res) => {
            this.$toast.hide()
            if (window.paymoney) {
              const paymoney = window.paymoney
              const url = window.vclcallback
              if (res == 1) {
                this.$router.push({ path: '/pay?amount=' + paymoney + '&callback=' + url })
              }
              if (res == 99) {
                console.log('多签钱包未注册')
                this.$router.push({ path: '/InviteMembers' })
              }
            } else {
              if (res == 1) {
                this.$router.push({ path: '/home/wallet' })
              }
              if (res == 99) {
                console.log('多签钱包未注册')
                this.$router.push({ path: '/InviteMembers' })
              }
            }

          })
          .catch((err) => {
            this.$toast.hide()
            this.$toast.failed(err)
            this.logout()
            this.$throw('[APP.VUE-initApp]' + err)
          })
      }
    },
    logout () {
      this.$store.commit('app/SET_LOADOVER', true)
      this.$router.replace({ path: '/' })
    }
  }
}
</script>

<style>
html,
body,
#app {
  height: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app {
  background-color: var(--whiteBgColor);
}

div {
  box-sizing: border-box;
}
d* {
  margin: 0;
  padding: 0;
}
.push-enter-active,
.push-leave-active {
  transition: all 0.4s;
}
.push-leave-to {
  opacity: 0;
  transform: translateX(-20%);
}
.push-enter-to {
  opacity: 0;
  transform: translateX(100%);
}
</style>



// WEBPACK FOOTER //
// src/App.vue